<template>
    <div>
        <FormTitle title="模板详情"/>
        <a-form @submit="handleSubmit" :form="form">
           

            <a-form-item label="模板名称" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'templatename',
                        {
                            initialValue: record.templatename,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="模板编码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'templatecode',
                        {
                            initialValue: record.templatecode,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="短信模板类型" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'templatetypemname',
                        {
                            initialValue: record.templatetypemname,
                        }
                    ]"
                />
            </a-form-item>
            
            <a-form-item label="模板内容" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                  <a-textarea  style="width:500px"
                    v-decorator="[
                        'templatetext',
                        {
                            initialValue: record.templatetext,
                        }
                    ]"
                 />
            </a-form-item>
            <a-form-item label="模版状态" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    style="width:500px"
                    v-decorator="[
                        'applystatusname',
                        {
                            initialValue: record.applystatusname,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="签名申请平台" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    style="width:500px"
                    v-decorator="[
                        'applyoriginname',
                        {
                            initialValue: record.applyoriginname,
                        }
                    ]"
                />
           </a-form-item>

            <a-form-item label="模板说明" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'remark',
                        {
                            initialValue: record.remark,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="提交审核时间" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'applytime',
                        {
                            initialValue: record.applytime,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="失败原因" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'reason',
                        {
                            initialValue: record.reason,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="阿里云返回id" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'requestid',
                        {
                            initialValue: record.requestid,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="创建时间" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'createtime',
                        {
                            initialValue: record.createtime,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="创建人" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                 <a-input
                    style="width:500px"
                    v-decorator="[
                        'createuser',
                        {
                            initialValue: record.createuser,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="修改时间" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    style="width:500px"
                    v-decorator="[
                        'updatetime',
                        {
                            initialValue: record.updatetime,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="修改人" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                   <a-input
                    style="width:500px"
                    v-decorator="[
                        'updateuser',
                        {
                            initialValue: record.updateuser,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-model-item   style="text-align: center">
                <a-button type="primary" @click="refresh">
                    刷新状态
                </a-button>

                <a-button type="primary" style="margin-left: 20px;" @click="handleCancel">
                    返回
                </a-button>    
            </a-form-model-item>
        </a-form>
    </div>
</template>

<script>
import FormTitle from "../../../components/FormTitle.vue";
import { mapState } from "vuex";

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 }
};

export default {
    data() {
        return {
            formItemLayout,
            formLayout: "horizontal",
            form: this.$form.createForm(this),
            disabled:  true 
        };
    },
    computed: {
        ...mapState("smsmanager", {
            record: function(state) {
                //这里需要注意 this 指向问题, 如果用箭头函数, 会有this作用域的问题
                return   state.record;
            }
        })
    },
    methods: {
        //域名信息表单提交
        handleSubmit(e) {
            e.preventDefault();
        },

        // 刷新签名申请状态
        refresh() {
            this.confirmLoading = true;
            let c_params = {};
            c_params.id=this.record.id;
            this.$store
                .dispatch({
                    type: "smsmanager/queryTemplatteApplyStatus",
                    params: c_params
                })
                .then((response) => {
                    if(response.data.success == '1'){
                        console.log(response)
                        this.confirmLoading = false;
                        this.message.success("更新成功！")
                        const { query } = this.$route;

                        this.$store.dispatch({
                            type: "smsmanager/detailTemplateApply",
                            params: query,
                            showMsg: false
                        });
                    }
                });
            
        },

        handleCancel() {
            this.$router.back(-1);
        },

    },
    mounted() {

        const { query } = this.$route;

        this.$store.dispatch({
            type: "smsmanager/detailTemplateApply",
            params: query,
            showMsg: false
        });
    },
    components: {
        FormTitle
    }
};
</script>

<style scoped>
</style>